module.exports = __webpack_public_path__ + "static/media/living room-02.9013e2a0.jpg";